import script from "./Home-SplashAd.vue?vue&type=script&setup=true&lang=js"
export * from "./Home-SplashAd.vue?vue&type=script&setup=true&lang=js"

import "./Home-SplashAd.vue?vue&type=style&index=0&id=0cb48fe0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb48fe0"]])

export default __exports__